<template>
    <header class="aar-header">
        <div class="aar-header__content centered-flex">
            <router-link to="/">
                <img src="../assets/images/logo.png" loading="lazy" width="86" heigth="52" alt="Website Logo" class="aar-header__logo">
            </router-link>
            <nav class="aar-header__navigation">
                <router-link to="/info" class="aar-header__navigation-link">{{ $t('menu1') }}</router-link>
                <router-link to="/models" class="aar-header__navigation-link">{{ $t('menu2') }}</router-link>
                <div class="aar-headar__language-container">
                    <span id="tr" @click="changeLocale('tr')" :class="{'selected-language': currentLang === 'tr'}" class="aar-header__language-container__option">TR</span>
                    <span class="aar-header__language-separator">|</span>
                    <span id="en" @click="changeLocale('en')" :class="{'selected-language': currentLang === 'en'}" class="aar-header__language-container__option">EN</span>
                </div>
            </nav>
            <resp-menu @menuOpen="toggleScrollState" @menuClosed="unblockScroll" class="hidden-desktop"></resp-menu>
        </div>
    </header>
</template>

<script>

import RespMenu from "./reusable/RespMenu";

export default {
  name: 'ACHeader',
  data(){
      return {
          isScrollBlocked: false
      }
  },
  computed: {
      currentLang: function(){
          return this.$i18n.locale
      }
  },
  methods: {
      changeLocale(id){
        this.$i18n.locale = id
      },

      toggleScrollState() {
          this.isScrollBlocked = !this.isScrollBlocked
          this.checkScrollClass()
      },

      unblockScroll(){
          this.isScrollBlocked = false
          this.checkScrollClass()
      },

      checkScrollClass(){
          const body = document.getElementsByTagName('body')[0]
          if(this.isScrollBlocked) {
              body.classList.add("blocked-scroll")
          } else {
              body.classList.remove("blocked-scroll")
          }
      }
  },

  components: {
      RespMenu: RespMenu
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/core/variables.scss";
  @import "../styles/global/helpers.scss";

  .aar-header__language-container{
      display: inline-flex;
      align-items: center;
  }

  .aar-header__language-container__option{
      font-size: 1.4rem;
      color: white;
      cursor: pointer;
      text-decoration: none;
  }

  .selected-language{
      font-weight: 700;
  }

  .aar-header__language-separator{
      color: white;
      font-size: 1.3rem;
      font-weight: 600;
      margin: 0 .6rem;
  }
  
  .aar-header{
      height: $header-height;
      grid-column: 1 / -1;
      background-color: black;
      display: grid;
      grid-template-columns: inherit;
      align-items: center;

      &__content{
          font-family: $main-font;
          grid-column: 2 / 12;
          width: 100%;
        justify-content: space-between;
        
      }

      &__navigation {
        
          display: flex;
          width: 30%;


          &-link {
              font-size: 1.4rem;
              color: white;
              cursor: pointer;
              user-select: none;
              text-decoration: none;
              position: relative;
              white-space: nowrap;

            &:not(:last-child) {
                margin-right: 3.8rem;
            }

          }
      }
  }


  a.aar-header__navigation-link::after{
    content: '';
    position: absolute;
    left: 50%;
    bottom: -4px;
    width: 0px;
    height: 2px;
    background: white;
    transition: all 0.45s;
}

    a.aar-header__navigation-link:hover:after {
        width: 100%;
        left: 0;
    }

  a.aar-header__navigation-link:active{
      outline: none;
  }
  


  @media screen and (max-width: $tablet-portrait){
      .aar-header__navigation {
          display: none;
      }


  }
</style>
